import throttle from 'lodash.throttle';
import { useState, useEffect, useMemo } from 'react';
import { buildVortexRasterUrl } from '@rendering/product-preview';
import { getDevicePixelRatio } from '../utils/devicePixelRatio';
export function useThrottledRasterUrl(_ref) {
  let {
    view,
    renderOptions,
    containerWidth,
    cimDocUrl,
    throttleWaitMs
  } = _ref;
  const [throttledUrl, setThrottledUrl] = useState('');
  const buildThrottledUrl = useMemo(() => throttle(_ref2 => {
    let {
      view,
      renderOptions,
      containerWidth,
      cimDocUrl
    } = _ref2;
    const vortexRasterUrl = buildVortexRasterUrl({
      cimDocUrl,
      modelUrl: view.vortex.model.url,
      stageUrl: view.vortex.stage.url,
      width: containerWidth,
      bgColor: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.bgColor,
      format: renderOptions === null || renderOptions === void 0 ? void 0 : renderOptions.format
    });
    setThrottledUrl(vortexRasterUrl);
  }, throttleWaitMs), [throttleWaitMs]);
  useEffect(() => {
    if (!containerWidth) {
      return;
    }
    buildThrottledUrl({
      view,
      renderOptions,
      containerWidth: Math.ceil(containerWidth * getDevicePixelRatio()),
      cimDocUrl
    });
  }, [buildThrottledUrl, view, renderOptions, containerWidth, cimDocUrl]);
  return throttledUrl;
}